import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { map, take, skipWhile } from 'rxjs/operators';

import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  /**
   * @ignore
   */
  constructor(private authService: AuthService, private router: Router) {}

  /**
   * checks if user is logged in, if yes user can access
   * if no, user is redirected to login
   * @param route
   * @param state
   * @returns
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.authService.isAuthenticated.pipe(
      skipWhile((value) => value === null),
      take(1),
      map((token) => {
        const isAuth = !!token;
        if (isAuth) {
          console.log(`Auth guard: MOZE`);
          return true;
        }
        console.log('Auth guard: NE MOZE');
        // return this.router.createUrlTree(['/login']);
        this.router.navigate(['/login'], {
          queryParams: { returnUrl: state.url },
        });
        return false;
      })
      // tap(isAuth => {
      //   if (!isAuth) {
      //     this.router.navigate(['/auth']);
      //   }
      // })
    );
  }
}
